import { SOURCE } from '@/config/events'

export default function useError() {
  function createErrorResponse(error) {
    return Object.assign(
      {
        status: error?.response?.status ?? 999,
        source: SOURCE.BACKEND,
        infoMessages: [],
      },
      error?.response?.data
    )
  }

  function jumpToError(el, execute = false, query = '.card--invalid') {
    if (execute) {
      window.setTimeout(() => {
        el.querySelector(query)?.scrollIntoView({
          behavior: 'smooth',
        })
      }, 500)
    }
  }
  return {
    createErrorResponse,
    jumpToError,
  }
}
